/* byChapters myChapters page: the three-step idea form, similar-idea suggestions, reference image resizing,
   "I'd build this" support and board filters. Talks to the myChapters app through the Shopify app proxy
   (/apps/mychapters/*). Loaded only on /pages/mychapters. No dependencies (bc-mc-similarity.js is optional). */
(function () {
  'use strict';
  var root = document.querySelector('[data-bcm]');
  if (!root) return;

  var live = root.getAttribute('data-live') === 'true';
  var signedIn = root.getAttribute('data-signed-in') === 'true';
  var endpoint = root.getAttribute('data-endpoint') || '/apps/mychapters';
  var pagePath = root.getAttribute('data-page') || location.pathname;
  var form = root.querySelector('[data-bcm-form]');
  var panel = root.querySelector('[data-bcm-panel]');
  var done = root.querySelector('[data-done]');
  var toastEl = root.querySelector('[data-toast]');
  var dialog = root.querySelector('[data-signin]');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var renderedAt = Date.now();
  var nonce = makeNonce();
  var image = null; // {data, type, name}
  var sawSimilar = '';
  var cards = [];
  try { cards = JSON.parse((root.querySelector('[data-bcm-cards]') || {}).textContent || '[]'); } catch (e) { cards = []; }

  var params = new URLSearchParams(location.search);
  // Site links arrive as "#share&from=…" fragments (a ?from= query would mint a crawlable URL per source); emails may still use the query, so read both.
  var hashParams = new URLSearchParams(location.hash.replace(/^#/, ''));
  var SOURCE_BY_PARAM = { home: 'Homepage', product: 'Product page', shelf: 'My Shelf', help: 'Help Centre', search: 'Search', email: 'Email', order: 'Order follow-up' };
  var source = SOURCE_BY_PARAM[params.get('from') || hashParams.get('from')] || 'Idea page';
  var sourceProduct = params.get('product') || hashParams.get('product') || '';
  if (!/^\d+$/.test(sourceProduct)) sourceProduct = '';

  function makeNonce() {
    var a = new Uint8Array(12);
    (window.crypto || window.msCrypto).getRandomValues(a);
    return Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
  }
  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function scrollTo(el) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0) - 16;
    window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
  }
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  }
  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) { /* optional */ }
  }
  function api(path, options) {
    return fetch(endpoint + path, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, options || {}))
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) { return { status: res.status, body: body }; });
      });
  }

  /* ---------------- Steps ---------------- */
  var current = 1;
  function showStep(n, focus) {
    current = n;
    $$('[data-step]', form).forEach(function (box) { box.hidden = Number(box.getAttribute('data-step')) !== n; });
    $$('[data-progress]').forEach(function (li) {
      var i = Number(li.getAttribute('data-progress'));
      li.classList.toggle('is-current', i === n);
      li.classList.toggle('is-done', i < n);
      if (i === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
    });
    if (focus !== false) {
      var box = $('[data-step="' + n + '"]', form);
      scrollTo(panel);
      if (box) box.focus({ preventScroll: true });
    }
  }

  function setError(name, msg) {
    var p = $('[data-error="' + name + '"]', form);
    var input = form.elements[name];
    if (p) { p.textContent = msg || ''; p.hidden = !msg; }
    if (input && input.setAttribute && !(input instanceof RadioNodeList)) {
      if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    }
  }
  function value(name) {
    var el = form.elements[name];
    if (!el) return '';
    if (el instanceof RadioNodeList) return el.value || '';
    if (el.type === 'checkbox') return el.checked;
    return (el.value || '').trim();
  }
  function checkedValues(name) {
    return $$('input[name="' + name + '"]:checked', form).map(function (i) { return i.value; });
  }

  function validate(step) {
    var firstBad = null;
    if (step === 1) {
      var t = value('title');
      if (t.length < 3) { setError('title', 'Tell us your idea in a few words.'); firstBad = firstBad || form.elements.title; } else setError('title', '');
      if (!value('world')) { setError('world', 'Pick the closest kind of world, or Something else.'); firstBad = firstBad || $('input[name="world"]', form); } else setError('world', '');
    }
    if (step === 2) {
      var link = value('link');
      if (link && !/^https?:\/\//i.test(link)) {
        if (/^[\w-]+(\.[\w-]+)+(\/\S*)?$/.test(link)) form.elements.link.value = link = 'https://' + link;
      }
      if (link && !/^https?:\/\/[^\s/$.?#].[^\s]*$/i.test(link)) { setError('link', 'That link doesn’t look right. It should start with https://'); firstBad = firstBad || form.elements.link; } else setError('link', '');
      if (image && !value('imageOk')) { setError('image', 'Please confirm you’re allowed to share this image, or remove it.'); firstBad = firstBad || $('input[name="imageOk"]', form); } else setError('image', '');
    }
    if (step === 3 && form.elements.email) {
      var needs = !live || $$('[data-needs-email]:checked', form).length > 0;
      var em = value('email');
      if (needs && !em) { setError('email', live ? 'Add your email so we can keep you posted.' : 'Add your email so we can reply.'); firstBad = firstBad || form.elements.email; }
      else if (em && !/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(em)) { setError('email', 'That email address doesn’t look right.'); firstBad = firstBad || form.elements.email; }
      else setError('email', '');
    }
    if (firstBad) { firstBad.focus(); return false; }
    return true;
  }

  $$('[data-next]', form).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!validate(current)) return;
      showStep(Number(btn.getAttribute('data-next')));
    });
  });
  $$('[data-prev]', form).forEach(function (btn) {
    btn.addEventListener('click', function () { showStep(Number(btn.getAttribute('data-prev'))); });
  });
  // Enter in a text field moves to the next step instead of submitting early.
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.target.tagName === 'TEXTAREA' || e.target.type === 'submit' || e.target.tagName === 'BUTTON') return;
    if (current < 3) {
      e.preventDefault();
      var next = $('[data-step="' + current + '"] [data-next]', form);
      if (next) next.click();
    }
  });

  /* ---------------- Similar ideas already on the board ---------------- */
  var similarBox = $('[data-similar]', form);
  var similarTimer;
  function renderSimilar() {
    if (!similarBox || !window.MCSimilarity || !cards.length) return;
    var t = value('title');
    if (t.length < 4) { similarBox.hidden = true; return; }
    var concepts = cards.map(function (c) { return { title: c.t, keywords: [], world: c.w, card: c }; });
    var ranked = window.MCSimilarity.rankConcepts({ title: t, world: value('world') }, concepts, 0.5, 3);
    if (!ranked.length) { similarBox.hidden = true; sawSimilar = ''; return; }
    sawSimilar = ranked[0].concept.card.h;
    similarBox.innerHTML = '';
    var h = document.createElement('p');
    h.className = 'bcm-similar__h';
    h.textContent = ranked.length > 1 ? 'These ideas are already on the board:' : 'This idea is already on the board:';
    var ul = document.createElement('ul');
    ul.className = 'bcm-similar__list';
    ranked.forEach(function (r) {
      var c = r.concept.card;
      var li = document.createElement('li');
      li.className = 'bcm-similar__item';
      var info = document.createElement('div');
      var b = document.createElement('b'); b.textContent = c.t;
      var small = document.createElement('small'); small.textContent = countText(c.n, false);
      info.appendChild(b); info.appendChild(small);
      li.appendChild(info);
      var link = document.createElement('a');
      link.className = 'bcm-btn bcm-btn--ghost';
      link.href = '#idea-' + c.h;
      link.textContent = live ? 'Back this one' : 'See it';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var card = root.querySelector('#idea-' + CSS.escape(c.h));
        scrollTo(card);
        var btn = card && card.querySelector('[data-support]');
        if (btn && btn.getAttribute('aria-pressed') !== 'true') setTimeout(function () { btn.click(); }, reduceMotion ? 0 : 450);
      });
      li.appendChild(link);
      ul.appendChild(li);
    });
    var note = document.createElement('p');
    note.className = 'bcm-similar__note';
    note.textContent = 'Yours is different? Carry on. Similar ideas still help us see what people want.';
    similarBox.appendChild(h); similarBox.appendChild(ul); similarBox.appendChild(note);
    similarBox.hidden = false;
  }
  form.elements.title.addEventListener('input', function () {
    if (value('title').length >= 3) setError('title', '');
    clearTimeout(similarTimer);
    similarTimer = setTimeout(renderSimilar, 350);
  });
  if (form.elements.email) form.elements.email.addEventListener('input', function () { setError('email', ''); });
  if (form.elements.link) form.elements.link.addEventListener('input', function () { setError('link', ''); });
  $$('input[name="world"]', form).forEach(function (r) { r.addEventListener('change', function () { setError('world', ''); renderSimilar(); }); });

  /* ---------------- Details: counter and reference image ---------------- */
  var counter = $('[data-counter="description"]', form);
  if (counter) form.elements.description.addEventListener('input', function () { counter.textContent = form.elements.description.value.length + ' / 2000'; });

  var imgInput = $('[data-image-input]', form);
  var preview = $('[data-preview]', form);
  var imgOk = $('[data-image-ok]', form);
  function clearImage() {
    image = null;
    if (imgInput) imgInput.value = '';
    if (preview) preview.hidden = true;
    if (imgOk) { imgOk.hidden = true; imgOk.querySelector('input').checked = false; }
    setError('image', '');
  }
  function resize(file) {
    // Redraw on a canvas: keeps uploads small and strips hidden photo data such as GPS location.
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var max = 1600, w = img.naturalWidth, h = img.naturalHeight;
        var scale = Math.min(1, max / Math.max(w, h));
        var cw = Math.max(1, Math.round(w * scale)), ch = Math.max(1, Math.round(h * scale));
        var canvas = document.createElement('canvas');
        canvas.width = cw; canvas.height = ch;
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, cw, ch);
        ctx.drawImage(img, 0, 0, cw, ch);
        URL.revokeObjectURL(url);
        resolve(canvas.toDataURL('image/jpeg', 0.82));
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('unreadable')); };
      img.src = url;
    });
  }
  if (imgInput) {
    imgInput.addEventListener('change', function () {
      var file = imgInput.files && imgInput.files[0];
      if (!file) return;
      if (!/^image\/(jpeg|png|webp)$/.test(file.type)) { clearImage(); setError('image', 'Please use a JPG, PNG or WebP image.'); return; }
      if (file.size > 25 * 1024 * 1024) { clearImage(); setError('image', 'That image is too large. Please choose one under 25 MB.'); return; }
      setError('image', '');
      resize(file).then(function (dataUrl) {
        if (dataUrl.length > 3.2 * 1024 * 1024) { clearImage(); setError('image', 'That image is too large.'); return; }
        image = { data: dataUrl.split(',')[1], type: 'image/jpeg', name: (file.name || 'reference').replace(/\.[^.]+$/, '') + '.jpg' };
        $('[data-preview-img]', form).src = dataUrl;
        preview.hidden = false;
        imgOk.hidden = false;
      }).catch(function () { clearImage(); setError('image', 'We couldn’t read that image. Please try another.'); });
    });
    $('[data-image-remove]', form).addEventListener('click', function () { clearImage(); imgInput.focus(); });
  }

  /* ---------------- About you ---------------- */
  var emailField = $('[data-email-field]', form);
  $$('[data-needs-email]', form).forEach(function (cb) {
    cb.addEventListener('change', function () {
      if (!live || !emailField) return;
      var any = $$('[data-needs-email]:checked', form).length > 0;
      emailField.hidden = !any;
      if (any && !value('email')) form.elements.email.focus();
      if (!any) setError('email', '');
    });
  });

  /* ---------------- Submit ---------------- */
  var submitBtn = $('[data-submit]', form);
  var formError = $('[data-form-error]', form);
  var ERROR_STEP = { title_required: ['title', 1], email_required: ['email', 3], email_invalid: ['email', 3], image_permission: ['image', 2], image_type: ['image', 2], image_too_big: ['image', 2] };

  function payload() {
    return {
      title: value('title'),
      description: value('description'),
      world: value('world'),
      style: checkedValues('style'),
      lighting: value('lighting'),
      size: value('size'),
      difficulty: value('difficulty'),
      link: value('link'),
      image: image,
      imageOk: Boolean(image && value('imageOk')),
      name: value('name') || '',
      email: value('email') || '',
      contactOk: value('contactOk') === true,
      marketingOk: value('marketingOk') === true,
      source: source,
      product: sourceProduct,
      sawSimilar: sawSimilar,
      hp: value('website'),
      t: Date.now() - renderedAt,
      nonce: nonce
    };
  }

  function busy(on) {
    submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    submitBtn.disabled = on;
    submitBtn.textContent = on ? 'Adding your idea…' : 'Add my idea';
  }

  function showDone(ref, opts) {
    opts = opts || {};
    form.hidden = true;
    $('.bcm-progress').hidden = true;
    done.hidden = false;
    $('[data-ref-wrap]', done).hidden = !ref;
    if (ref) $('[data-ref]', done).textContent = ref;
    $('[data-done-account]', done).hidden = !signedIn;
    $('[data-done-email]', done).hidden = !opts.emailed;
    scrollTo(panel);
    done.focus({ preventScroll: true });
  }

  function fallbackSubmit(data) {
    // App not connected yet: send the idea to the shop's inbox with Shopify's contact form.
    var f = document.getElementById('bcm-fallback');
    if (!f) return false;
    var lines = [
      'myChapters idea', '',
      'Idea: ' + data.title,
      'World: ' + (data.world || '-'),
      'Style: ' + (data.style.join(', ') || '-'),
      'Lighting: ' + (data.lighting || '-'),
      'Size: ' + (data.size || '-'),
      'Complexity: ' + (data.difficulty || '-'),
      'Reference link: ' + (data.link || '-'),
      'Keep me posted: ' + (data.contactOk ? 'yes' : 'no'),
      'News and new worlds: ' + (data.marketingOk ? 'yes (please add to the newsletter)' : 'no'),
      'From: ' + data.source + (data.product ? ' (product ' + data.product + ')' : ''),
      '', 'Tell us more:', data.description || '-'
    ];
    f.querySelector('[name="contact[email]"]').value = data.email || root.getAttribute('data-email') || '';
    f.querySelector('[name="contact[name]"]').value = data.name || '';
    f.querySelector('[name="contact[body]"]').value = lines.join('\n');
    try { sessionStorage.setItem('bcm-fallback', '1'); } catch (e) { /* ignore */ }
    f.submit();
    return true;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validate(1)) { showStep(1); validate(1); return; }
    if (!validate(2)) { showStep(2); validate(2); return; }
    if (!validate(3)) return;
    formError.hidden = true;
    var data = payload();
    busy(true);
    if (!live) {
      if (!fallbackSubmit(data)) { busy(false); formError.textContent = 'Sorry, something went wrong. Please try again in a moment, or send your idea through the chat or contact page.'; formError.hidden = false; }
      return;
    }
    api('/idea', { method: 'POST', body: JSON.stringify(data) }).then(function (r) {
      busy(false);
      if (r.status === 200 && r.body.ok) {
        publish('mychapters_idea_submitted', { world: data.world, source: data.source, signed_in: signedIn });
        showDone(r.body.ref, { emailed: data.contactOk });
        return;
      }
      var code = r.body && r.body.error;
      var msg = (r.body && r.body.message) || 'Sorry, we couldn’t save that. Please try again.';
      if (ERROR_STEP[code]) {
        showStep(ERROR_STEP[code][1]);
        setError(ERROR_STEP[code][0], msg);
        return;
      }
      formError.textContent = msg + (r.status >= 500 || r.status === 0 ? ' If it keeps happening, send it to us through the chat or contact page instead.' : '');
      formError.hidden = false;
    }).catch(function () {
      busy(false);
      formError.textContent = 'We couldn’t reach byChapters just now. Please check your connection and try again, or send your idea through the chat or contact page.';
      formError.hidden = false;
    });
  });

  var again = $('[data-again]', done);
  if (again) {
    again.addEventListener('click', function () {
      form.reset();
      clearImage();
      if (counter) counter.textContent = '0 / 2000';
      if (similarBox) similarBox.hidden = true;
      if (live && emailField) emailField.hidden = true;
      sawSimilar = '';
      nonce = makeNonce();
      renderedAt = Date.now();
      done.hidden = true;
      form.hidden = false;
      $('.bcm-progress').hidden = false;
      showStep(1);
    });
  }

  // Coming back from the contact-form fallback.
  if (document.querySelector('[data-fallback-posted]')) {
    var wasOurs = false;
    try { wasOurs = sessionStorage.getItem('bcm-fallback') === '1'; sessionStorage.removeItem('bcm-fallback'); } catch (e) { wasOurs = true; }
    if (wasOurs) setTimeout(function () { showDone('', { emailed: true }); }, 50);
  }

  /* ---------------- Board: filters ---------------- */
  var filters = $('[data-filters]');
  if (filters) {
    filters.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter]');
      if (!btn) return;
      var w = btn.getAttribute('data-filter');
      $$('[data-filter]', filters).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      var shown = 0;
      $$('[data-grid] [data-card-li]').forEach(function (li) {
        var on = !w || li.getAttribute('data-world') === w;
        li.hidden = !on;
        if (on) shown++;
      });
      var none = $('[data-nomatch]');
      if (none) none.hidden = shown > 0;
    });
  }

  /* ---------------- Board: I'd build this ---------------- */
  function countText(n, released) {
    if (n > 0) return n + (n === 1 ? ' person ' : ' people ') + (released ? 'asked for this' : 'would build this');
    return 'Be the first to back this';
  }
  function setCount(card, n) {
    var p = card && card.querySelector('[data-count]');
    if (!p) return;
    p.setAttribute('data-n', n);
    p.innerHTML = '';
    if (n > 0) {
      var b = document.createElement('b'); b.textContent = n;
      p.appendChild(b);
      p.appendChild(document.createTextNode(' ' + (n === 1 ? 'person' : 'people') + ' would build this'));
    } else {
      p.textContent = 'Be the first to back this';
    }
  }
  function openSignIn(handle) {
    var ret = pagePath + '?support=' + encodeURIComponent(handle) + '#idea-' + handle;
    var link = dialog && dialog.querySelector('[data-signin-link]');
    if (link) link.href = '/customer_authentication/login?return_to=' + encodeURIComponent(ret);
    if (dialog && dialog.showModal) dialog.showModal();
    else location.href = link ? link.href : '/customer_authentication/login';
  }
  if (dialog) {
    dialog.querySelector('[data-signin-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  function support(btn, forceAdd) {
    var handle = btn.getAttribute('data-support');
    if (!signedIn) { openSignIn(handle); return Promise.resolve(); }
    var card = btn.closest('[data-card]');
    var was = btn.getAttribute('aria-pressed') === 'true';
    if (forceAdd && was) return Promise.resolve();
    var add = forceAdd || !was;
    var countEl = card.querySelector('[data-count]');
    var before = countEl ? Number(countEl.getAttribute('data-n')) || 0 : 0;
    btn.setAttribute('aria-pressed', add ? 'true' : 'false');
    setCount(card, Math.max(0, before + (add ? 1 : -1)));
    btn.disabled = true;
    return api('/support', { method: 'POST', body: JSON.stringify({ card: handle, action: add ? 'add' : 'remove', source: forceAdd ? 'sign-in return' : 'board' }) }).then(function (r) {
      btn.disabled = false;
      if (r.status === 200 && r.body.ok) {
        if (typeof r.body.supporters === 'number') setCount(card, r.body.supporters);
        toast(add ? 'Thanks. We’ve added your support.' : 'Support removed.');
        if (add) publish('mychapters_idea_supported', { card: handle });
        return;
      }
      btn.setAttribute('aria-pressed', was ? 'true' : 'false');
      setCount(card, before);
      if (r.status === 401 && r.body.needLogin) { signedIn = false; openSignIn(handle); return; }
      toast((r.body && r.body.message) || 'Sorry, that didn’t work. Please try again.');
    }).catch(function () {
      btn.disabled = false;
      btn.setAttribute('aria-pressed', was ? 'true' : 'false');
      setCount(card, before);
      toast('We couldn’t reach byChapters just now. Please try again.');
    });
  }
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-support]');
    if (btn) support(btn);
  });

  if (live) {
    // Back from signing in to support an idea: add it now.
    var pending = params.get('support');
    if (pending && signedIn) {
      var btn = root.querySelector('[data-support="' + CSS.escape(pending) + '"]');
      if (btn) setTimeout(function () { scrollTo(btn.closest('[data-card]')); support(btn, true); }, 300);
      params.delete('support');
      var qs = params.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    }
    // Fresh counts (the page itself may be cached for a few minutes).
    if (cards.length) {
      api('/board').then(function (r) {
        if (r.status !== 200 || !r.body.cards) return;
        Object.keys(r.body.cards).forEach(function (h) {
          var card = root.querySelector('[data-card="' + CSS.escape(h) + '"]');
          var p = card && card.querySelector('[data-count]');
          if (p && Number(p.getAttribute('data-n')) !== r.body.cards[h].supporters) setCount(card, r.body.cards[h].supporters);
        });
      }).catch(function () { /* counts stay as rendered */ });
    }
  }

  // "Share an idea" links elsewhere on the page start the form at step 1.
  $$('a[href="#share"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!done.hidden) return;
      e.preventDefault();
      history.replaceState(null, '', location.pathname + location.search + '#share');
      showStep(1);
    });
  });
  if (/^#share(&|$)/.test(location.hash) && !document.querySelector('[data-fallback-posted]')) setTimeout(function () { showStep(1); }, 200);
})();
